import type { CameraName } from '@digger/shared';

export type ConnectionState =
  | 'disconnected'
  | 'signaling'
  | 'connecting'
  | 'connected'
  | 'reconnecting';

/**
 * Console-side session state: which camera is dominant, and the E-STOP
 * latch. The latch is deliberately sticky — it clears only on explicit
 * operator reset, never on reconnect or timeout.
 */
export class ConsoleState {
  dominant: CameraName = 'front';
  estopLatched = false;
  connection: ConnectionState = 'disconnected';

  swapCamera(): CameraName {
    this.dominant = this.dominant === 'front' ? 'rear' : 'front';
    return this.dominant;
  }

  get pip(): CameraName {
    return this.dominant === 'front' ? 'rear' : 'front';
  }

  latchEstop(): void {
    this.estopLatched = true;
  }

  resetEstop(): void {
    this.estopLatched = false;
  }
}
